<template>
  <div class="flex flex-col items-center justify-center w-full p-16 relative">
    <div class="flex flex-col w-full max-w-6xl justify-center lg:pb-20">
      <img
        :style="[{ right: '-8%' }, { top: '-8%' }]"
        class="absolute w-1/2 lg:w-1/4 opacity-10"
        src="/img/cw-marketing/cw-shapes_dots.svg"
        alt="CW alt shapes"
      />
      <div class="flex flex-col items-start w-full lg:w-1/2 mb-12">
        <h6
          class="font-nunito text-lg mb-4 text-cw-300 uppercase tracking-widest"
        >
          Explore
        </h6>
        <h2 class="font-montserrat text-cw-900 font-bold text-4xl">
          See how these schools are using CareerWise
        </h2>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-6 gap-12">
        <div
          v-for="(tenant, i) in tenants"
          :id="tenant.id"
          :key="i"
          :ref="'tenant-' + i"
          class="cursor-pointer transition-all duration-300 ease-in-out hover:-translate-y-4 group flex flex-col items-center justify-center relative"
          @click="routeToExternalLink(tenant.site_url)"
        >
          <img
            v-if="tenant.logo"
            :src="tenant.logo"
            alt="Client Logo"
            class="transform transition-all duration-300 ease-in-out h-16"
          />
          <p
            class="mt-2 text-truegray-500 font-nunito text-sm text-center transition-all duration-300 ease-in-out"
          >
            {{ tenant.profile_title }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shared } from '../../../js/mixins/shared.js'
import { routeToExternalLink } from '../../../js/util/helper.js'
import { mapGetters } from 'vuex'

export default {
  mixins: [shared],

  data() {
    return {
      tenants: [],
    }
  },

  computed: {
    ...mapGetters({ settings: 'shared/getSettings' }),
  },

  mounted() {
    this.$set(this, 'tenants', this.settings.featured_tenants)
  },

  methods: {
    routeToExternalLink,
  },
}
</script>
